<template>
  <div v-if="!appIsReady">
    <ConfigureApp @configuration-initialized="onConfigurationInit" />
    <AuthenticateUser
      v-if="configurationIsInitialized && configuration"
      :configuration
      @user-initialized="userIsInitialized = true"
    />
  </div>
</template>

<script setup lang="ts">
import type { Undefinable } from 'ts-helpers'
import { computed, onBeforeMount, watch, ref } from 'vue'
import { AuthenticateUser, ConfigureApp } from '@/4_features/Configuration'
import {
  useConfiguration,
  disableGlobalLoader,
  type ConfigurationDTO
} from '@/5_entities/Configuration'
import { appMessenger } from '@/5_entities/Configuration'
import { lockScroll, unlockScroll } from '@/6_shared/lib'

const userIsInitialized = ref(false)
const configurationIsInitialized = ref(false)

const appIsReady = computed(() => userIsInitialized.value && configurationIsInitialized.value)

const { initApp } = useConfiguration()
///**
// * https://youtrack.intickets.ru/issue/A-1823/Poluchat-izmeneniya-cityId-ot-partnyora
// * перезаписывает location пользователя на тот,
// * который в ссылке принудительно, если
// * у партнера canOverrideCity и cityId не совпадают
// * @param userData

const configuration = ref<Undefinable<ConfigurationDTO>>(undefined)

const onConfigurationInit = (config?: ConfigurationDTO) => {
  configurationIsInitialized.value = true
  configuration.value = config
}

onBeforeMount(() => lockScroll())
watch(
  () => appIsReady.value,
  (val) => {
    disableGlobalLoader()
    if (val) unlockScroll()
    initApp()
    appMessenger.open()
  },
  {
    once: true
  }
)
</script>
